module.exports = __webpack_public_path__ + "static/img/icon1.86fdb01.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/images/icon1.png
// module id = pzd1
// module chunks = 1